import {Group, Text} from "@mantine/core";
import {ActivityPeriodStatus} from "@ots-frontend/ots-data";
import {IconCircle, IconCircleFilled} from "@tabler/icons-react";
import {getActivityPeriodStatusColorRef} from "../../../util/activity-period-ui-util";
import {FormattedDatabaseCode} from "../FormattedDatabaseCode/FormattedDatabaseCode";

type Props = {
  value: ActivityPeriodStatus
  withIcon?: boolean
  iconFill?: boolean
}

export const FormattedActivityPeriodStatus = (props: Props) => {
  const {value, withIcon = true, iconFill = true} = props;

  if (!withIcon) {
    return <FormattedDatabaseCode value={value}/>
  }

  return (
    <Group spacing="xs">
      <Text color={getActivityPeriodStatusColorRef(value)}>
        {iconFill ? <IconCircleFilled size={14}/> : <IconCircle size={14}/>}
      </Text>
      <FormattedDatabaseCode value={value}/>
    </Group>
  );
};
